import {
  FormContainerWithHeader,
  FormNumberInputAdornmentField,
  NewFormTextField,
  NewFromSelectField,
} from '../../../../../presentation';
import {
  QUOTE_STATUS_OPTIONS,
  QUOTE_TYPE_OPTIONS,
  getFieldProps,
} from '@converge/data';

import { useTranslation } from 'react-i18next';

interface IProps {
  isReadonly?: boolean;
}
export const QuoteInfoFormSection = ({ isReadonly }: IProps) => {
  const { t } = useTranslation();

  return (
    <FormContainerWithHeader
      title={t(
        'entities.quote.detail.content.sections.overview.title',
        'Basic information'
      )}
    >
      <NewFormTextField
        {...getFieldProps(
          'referenceId',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.referenceId`,
            'Reference Id'
          )
        )}
      />
      <NewFormTextField
        {...getFieldProps(
          'name',
          isReadonly,
          t(`quotes.detail.content.sections.overview.info.fields.name`, 'Name')
        )}
      />
      <NewFromSelectField
        {...getFieldProps(
          'type',
          isReadonly,
          t(`quotes.detail.content.sections.overview.info.fields.type`, 'Type')
        )}
        options={QUOTE_TYPE_OPTIONS}
      />
      <NewFromSelectField
        {...getFieldProps(
          'status',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.type`,
            'Status'
          )
        )}
        options={QUOTE_STATUS_OPTIONS}
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'ratedPremium',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.ratedPremium`,
            'Rated Premium'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'quotedPremium',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.quotedPremium`,
            'Quoted Premium'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'limit: ',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.limit: `,
            'Limit: '
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'retention',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.retention`,
            'Retention'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'quotedPremium',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.quotedPremium`,
            'Quoted Premium'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'minimumPremium',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.minimumPremium`,
            'Minimum Premium'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'technicalPremium',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.technicalPremium`,
            'Technical Premium'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'modifiedCoveragePremium',
          isReadonly,
          t(
            `quotes.detail.content.sections.overview.info.fields.modifiedCoveragePremium`,
            'Modified Coverage Premium'
          )
        )}
        thousandSeparator=","
      />
    </FormContainerWithHeader>
  );
};
